import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"
import AeraLogoImage from "../../../images/aera-logo.png"
import "./FormHeader.scss"

interface IFormHeaderProps {
    title?: string
    tagline?: string
    showLogo?: boolean
    titleWeight?: "medium" | "bold"
    showSandboxTitle?: boolean
}

const FormHeader = ({
    title = "",
    tagline = "",
    showLogo = true,
    titleWeight: titleWeight,
    showSandboxTitle,
}: IFormHeaderProps) => {
    const { t } = useTranslation()

    return (
        <div className="form-head">
            {showLogo && <img src={AeraLogoImage} className="img-center mt-3" alt="aera-logo" />}
            {showSandboxTitle ? (
                <span className="sandbox-label">SANDBOX</span>
            ) : (
                <h2 className={cn("title text-center header-message mt-2", titleWeight ? `weight-${titleWeight}` : undefined)}>
                    {title ? title : t("common.title")}
                </h2>
            )}
            {tagline && <div className="form-head__tagline">{tagline}</div>}
        </div>
    )
}

export default FormHeader
